export const Error403 = 'https://humanizadas-files.s3-sa-east-1.amazonaws.com/public/messages/error-403.jpg';
export const Error404 = 'https://humanizadas-files.s3-sa-east-1.amazonaws.com/public/messages/error-404.jpg';
export const Error500 = 'https://humanizadas-files.s3-sa-east-1.amazonaws.com/public/messages/error-500.jpg';
export const Expired = 'https://humanizadas-files.s3-sa-east-1.amazonaws.com/public/messages/expired.jpg';
export const notStarted = 'https://humanizadas-files.s3.sa-east-1.amazonaws.com/public/messages/not-started.jpg';
export const Maintenance = 'https://humanizadas-files.s3-sa-east-1.amazonaws.com/public/messages/maintenance.jpg';
export const DefaultError = 'https://humanizadas-files.s3-sa-east-1.amazonaws.com/public/messages/default-error.jpg';
export const NotAvailable = 'https://humanizadas-files.s3-sa-east-1.amazonaws.com/public/messages/not-available.jpg';
export const RegisterImg = 'https://humanizadas-files.s3-sa-east-1.amazonaws.com/public/register.jpg';
export const ThankYou = 'https://humanizadas-files.s3-sa-east-1.amazonaws.com/public/messages/thank-you.jpg';
export const RoleSelect = 'https://humanizadas-files.s3-sa-east-1.amazonaws.com/public/role-select.jpg';
export const Signup = 'https://humanizadas-files.s3-sa-east-1.amazonaws.com/public/signup.jpg';
export const SignupThankYou = 'https://humanizadas-files.s3-sa-east-1.amazonaws.com/public/signup_thank_you.jpg';
export const LastReport = 'https://humanizadas-files.s3-sa-east-1.amazonaws.com/public/last_report.jpg';

export default {
  Error403,
  Error404,
  Error500,
  Expired,
  notStarted,
  Maintenance,
  DefaultError,
  NotAvailable,
  RegisterImg,
  ThankYou,
  Signup,
  RoleSelect,
};
